export enum Role {
    User = 'User',
    Components = 'Components',
    ACL = 'ACL',
    Upload = 'Upload',
    Reports = 'Reports',
    Admin = 'Admin',
    Enginner = 'Engineer',
    Info = 'Info',
    CMTIntelligence = 'CMT Intelligence',
  
}
export enum SubRoleAdmin {
    Tickets = 'Tickets',
    ContractManufacturer='Contract Manufacturers',
    BusinessUnits='Business Units',
    CMSites='CM Sites',
    Commodities='Commodities',
    Manufacturers='Manufacturers',
    Distributers='Distributers',
    ManufacturerDistributers='Manufacturer Distributers',
    Years='Years',
    Users='Users',
    Quotes = 'Quotes',
    TFSites='TF Sites',
    TFCommodities='TF Commodities',
    Divisions='Divisions',
    Usage='Usage'

}

export enum SubRoleInfo {
    ContractManufacturerHelp='Contract Manufacturer Help',
    SupplierInfo='Supplier Info',
    CommodityManagerHelp='Commodity Manager Help',
    Terms='Terms',
    Policies='Policies',
    EngineerBOMHelp='Engineer Help',
}
export enum SubRoleParts {
    Dashboard = 'Dashboard',
    CBOM='CBOM',
    Parts='Parts',
    PartSearch='Part Search',
    CrossSearch='Cross Search',
    Alerts='Alert',
}
export enum SubRoleAcl {
    parts = 'Parts',
}
export enum SubRoleUpload {
    Requests = 'Requests',
    History = 'History',
    Quotes = 'UploadQuotes',
    Awards = 'Awards',
    LOAs='LOAs'
}
export enum SubRoleReports {
    Reports = 'Reports',
    ReportsTable = 'Table',
    ReportsGraph = 'Graph',

}

export enum SubRoleEngineer {
    SavedBOMs = 'Saved BOMs',
    }
export enum SubRoleIntelligence {
    VerityAgent = 'Verity Agent',
    }